import { atom } from '@reatom/framework'

import type { TradeType } from '@root/entities/trade-type'

export const tradeOrderTypeAtom = atom<TradeType.OrderType>(
  'market',
  'tradeOrderTypeAtom',
)
export const tradeSwapTypeAtom = atom<TradeType.SwapDirection>(
  'buy',
  'tradeSwapTypeAtom',
)

export const tradeTypeAtom = atom((ctx): TradeType.Type => {
  const orderType = ctx.spy(tradeOrderTypeAtom)
  const swapType = ctx.spy(tradeSwapTypeAtom)

  return `${orderType}-${swapType}`
}, 'tradeTypeAtom')
